//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResetVisibilitySettingsModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    handleReset() {
      this.$emit("reset-visibility-settings");
      this.hideModal();
    }
  }
});